import { render, staticRenderFns } from "./InstructeurDEAL.vue?vue&type=template&id=545f8417"
import script from "./InstructeurDEAL.vue?vue&type=script&lang=js"
export * from "./InstructeurDEAL.vue?vue&type=script&lang=js"
import style0 from "./InstructeurDEAL.vue?vue&type=style&index=0&id=545f8417&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports